import { SortDirection } from "@angular/material/sort";


export const DEFAULT_ORDER_BY = 'created_at';
export const DEFAULT_ORDER_DIRECTION: SortDirection = 'asc';
export const DEFAULT_PAGE_SIZE = 20;
